import "./Corporate.module.css";
import KurumsalKimlikBasligi from "@/reusable_sections/Header";
import BuroProfilimiz from "./sections/BuroProfilimiz";
import AvArbMuhammedCelik from "./sections/AvArbMuhammedCelik";
import ProfessionalEthics from "./sections/ProfessionalEthics";
import KurumsalAltBilgi from "@/reusable_sections/Footer";
export default function CorporatePage() {
  return <div>
      <KurumsalKimlikBasligi />
      <BuroProfilimiz />
      <AvArbMuhammedCelik />
      <ProfessionalEthics />
      <KurumsalAltBilgi />
    </div>;
}